/**
 * Premium subscription row subcomponent
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfirmButton from 'components/ConfirmButton';
import messages from './messages';

function PremiumRow({ user, onCancelSubscription }) {
  if (!user.pm) {
    return null;
  }

  return (
    <>
      <dt>
        <FormattedMessage {...messages.premiumUntil} />
      </dt>
      <dd className="mb-3">
        {user.premiumDate}
        <span className="ml-3 font-italic green500">
          <FormattedMessage {...messages.thanks} />
        </span>
        <FontAwesomeIcon
          icon={['far', 'thumbs-up']}
          className="ml-2 mr-3 red500"
        />
        {user.api.ar ? (
          <div className="mt-1 text-muted">
            <span className="mr-3">
              <FormattedMessage {...messages.recurring} />
            </span>
            <ConfirmButton
              bsStyle="default"
              bsSize="xs"
              onClick={onCancelSubscription}
              confirmationText={messages.confirmCancel}
            >
              <FormattedMessage {...messages.cancelRecurring} />
            </ConfirmButton>
          </div>
        ) : (
          <Button bsStyle="default" bsSize="xs" href="#subscription">
            <FormattedMessage {...messages.extend} />
          </Button>
        )}
      </dd>
    </>
  );
}

PremiumRow.propTypes = {
  user: PropTypes.object.isRequired,
  onCancelSubscription: PropTypes.func.isRequired,
};

export default PremiumRow;
